import { Fragment, type JSX } from "react";

import {
  AttributeGroupContent,
  AttributeGroupProps,
  AttributeGroupSimple,
  AttributeGroupVariant,
} from "@plansoft-configuration-renderer/components";

import { CustomAttributeGroupAccordion } from "./CustomAttributeGroupAccordion";

export function CustomAttributeGroup(props: AttributeGroupProps): JSX.Element {
  const { variant = AttributeGroupVariant.Accordion } = props;

  switch (variant) {
    case AttributeGroupVariant.Accordion:
      return <CustomAttributeGroupAccordion {...props} />;
    case AttributeGroupVariant.Simple:
      return <AttributeGroupSimple {...props} />;
    case AttributeGroupVariant.Content:
      return <AttributeGroupContent {...props} />;
    default:
      return <Fragment />;
  }
}
